import {Component, OnInit} from '@angular/core';
import {UserService} from "../../../shared/services/user.service";
import {ActivatedRoute, Router} from '@angular/router';
import {TextService} from "../../../shared/services/text.service";
import {SdkInitText} from "../../../model/user/sdk-init-text";
import {SessionService} from "../../../shared/services/session.service";
import {AccountEulaComponent} from "../../../shared/notification/account-eula/account-eula.component";
import {NzModalRef, NzModalService} from "ng-zorro-antd";
import {RegisterAccount} from "../../../model/register-account";

import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
  NgForm, ValidationErrors,
  ValidatorFn,
  Validators
} from "@angular/forms";
import {PasswordMatcher} from "../../../shared/utils/password-matcher-util";
import {AccountKvkkComponent} from "../../../shared/notification/account-kvkk/account-kvkk.component";
import {AccountEtkComponent} from "../../../shared/notification/account-etk/account-etk.component";
import { NetmeraService } from "../../../shared/services/netmera-service";
import { Register } from "../../../model/netmera-events/register";

@Component({
  selector: 'pa-signup-form',
  templateUrl: './signup-form.component.html',
  styleUrls: ['./signup-form.component.scss']
})
export class SignupFormComponent implements OnInit {

  showEula: boolean;
  showEtk: boolean;
  showKvkk: boolean;
  submitted: boolean;
  pinIsMatched: boolean;
  trackingId: string;
  formBuilder: FormBuilder = new FormBuilder();
  registerAccount: RegisterAccount = new RegisterAccount();
  tplModal: NzModalRef;
  textService: TextService;
  sdkInitTexts: Array<SdkInitText>;
  errorMessage: string;
  emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
  isLoginWebSdk: boolean = false;
  buttonName: string;
  merchantCode: string;

  signupForm = this.formBuilder.group({
    email: new FormControl(null, [Validators.required, Validators.pattern(this.emailPattern)]),
    pin: new FormControl(null, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
    repin: new FormControl(null, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
    kvkkAgreement: new FormControl(false),
    etkAgreement: new FormControl(false),
    eulaAgreement: new FormControl(false),
  }, {
    validator: PasswordMatcher('pin', 'repin')
  });

  constructor(private router: Router, private route: ActivatedRoute, private userService: UserService,
              private modalService: NzModalService, private sessionService: SessionService, textService: TextService,
              private netmeraService: NetmeraService,private register: Register) {
    this.textService = textService;
  }

  ngOnInit(): void {
    this.submitted = false;
    this.pinIsMatched = false;
    this.route.params.subscribe(params => {
      this.trackingId = params['trackingId'];
      this.setAccountFlags();
    });
  }

  setAccountFlags() {
    this.userService.setAccountFlags(this.trackingId).subscribe(response => {
      this.sessionService.getInitUser(this.trackingId).subscribe(response => {
        this.merchantCode = response?.requestHeader?.merchant?.merchantCode;
        this.netmeraService.pushEvent(this.register.setEventObject("UyeOlEkraniAcildi", this.merchantCode));
        this.sdkInitTexts = response.sdkInitTexts;
        this.showEula = response?.account?.showEula;
        this.showEtk = response?.account?.showEtk;
        this.showKvkk = response?.account?.showKvkk;
        this.isLoginWebSdk = response.loginWebSdk;
        this.setInitTexts();
        this.isShowAgreements();
      },error => {
        this.router.navigate(['/result/error', this.trackingId]);
      });
    }, error => {
      this.router.navigate(['/result/error', this.trackingId]);
    });
  }

  signup() {
    if (this.signupForm.invalid) {
      return;
    }
    this.userService.signup(this.registerAccountPopulate(), this.trackingId).subscribe(response => {
      this.submitted = true;
      this.netmeraService.pushEvent(this.register.setEventObject("UyeOlBasarili", this.merchantCode));
      this.router.navigate(['/route', this.trackingId]);
    }, error => {
      if(error.error.message == "3039"){
        this.netmeraService.pushEvent(this.register.setEventObject("GecersizSifreGirisi", this.merchantCode));
      }
      else {
        this.netmeraService.pushEvent(this.register.setEventObject("UyeOlBasarisiz", this.merchantCode));
      }
      this.submitted = false;
      this.errorMessage = error.error.consoleMessage;
    });
  }

  registerAccountPopulate() {
    this.registerAccount.pin = this.signupForm.get('pin').value;
    this.registerAccount.email = this.signupForm.get('email').value;
    this.registerAccount.etk = this.showEtk ? !!this.signupForm.get('etkAgreement').value : true;
    this.registerAccount.kvkk = this.showKvkk ? !!this.signupForm.get('kvkkAgreement').value : true;
    return this.registerAccount;
  }

  createAccountEulaModal(): void {
    this.tplModal = this.modalService.create({
      nzClassName: 'account-eula-modal',
      nzContent: AccountEulaComponent,
      nzMaskClosable: true,
      nzClosable: true,
      nzFooter: null,
      nzStyle: {
        width: '513px',
        height: '650px',
        'border-radius': '15px',
        'box-shadow': '0 0 15px 0 rgba(0, 0, 0, 0.25)',
        'background-color': '#ffffff'
      },
      nzComponentParams: {trackingId: this.trackingId}
    });
  }

  createAccountKvkkModal(): void {
    this.tplModal = this.modalService.create({
      nzClassName: 'account-eula-modal',
      nzContent: AccountKvkkComponent,
      nzMaskClosable: true,
      nzClosable: true,
      nzFooter: null,
      nzStyle: {
        width: '513px',
        height: '650px',
        'border-radius': '15px',
        'box-shadow': '0 0 15px 0 rgba(0, 0, 0, 0.25)',
        'background-color': '#ffffff'
      }
    });
  }

  createAccountEtkModal(): void {
    this.tplModal = this.modalService.create({
      nzClassName: 'account-eula-modal',
      nzContent: AccountEtkComponent,
      nzMaskClosable: true,
      nzClosable: true,
      nzFooter: null,
      nzStyle: {
        width: '513px',
        height: '650px',
        'border-radius': '15px',
        'box-shadow': '0 0 15px 0 rgba(0, 0, 0, 0.25)',
        'background-color': '#ffffff'
      }
    });
  }

  setInitTexts() {
    this.buttonName = this.isLoginWebSdk ? this.textService.keyValueMapping('registerButtonTextForTfs', 'Onayla', this.sdkInitTexts)
                        : this.textService.keyValueMapping('registerButtonText', 'Giriş Yap', this.sdkInitTexts);
  }

  messageState(value: any) {
    this.errorMessage = value;
  }

  isShowAgreements() {
    if (this.showEula) {
      this.signupForm.controls['eulaAgreement'].setValidators([Validators.requiredTrue]);
    } else {
      this.signupForm.controls['eulaAgreement'].clearValidators();
    }
    this.signupForm.controls['eulaAgreement'].updateValueAndValidity();
  }
}

